import { AttributionLinkSource } from 'common/constants/attribution-link-source';
import { Marketplaces } from 'common/constants/enums';

import { ApiService } from './api.service';

export interface CreateTemporaryLinkBody {
  expired_at: string;
  publisher_id?: number;
  marketplace: Marketplaces;
  product_links: Array<{ marketplace_item_id: string; link: string }>;
  region?: string;
}

export interface GetPublisherTemporaryLinksQuery {
  limit: number;
  offset: number;
  search?: string;
  region?: string;
  asins?: string[];
  w_item_ids?: string[];
}

export interface GenerateTemporaryLinkRequestBody {
  expired_at?: string,
  publisher_id: number,
  asins: string[],
  region?: string,
  source: AttributionLinkSource,
}

class TemporaryLinkServiceApi extends ApiService {
  createLink = (data: CreateTemporaryLinkBody) =>
    this.post('/admin/products/temporary-links', data);

  getPublisherLinks = (query: GetPublisherTemporaryLinksQuery, publisherId?: number) => {
    const path = publisherId
      ? `/admin/products/temporary-links/${publisherId}`
      : '/admin/products/temporary-links';

    return this.get(path, { params: query });
  };

  deleteTemporaryLink = (link: string, publisherId: number, region?: string) =>
    this.delete(`/admin/products/temporary-links/${publisherId}`, { link, region });

  downloadCsvFile = (region?: string) => this.get('/admin/download/temporary-links', {
    params: region ? { region } : {},
  });

  generateLink = (data: GenerateTemporaryLinkRequestBody) =>
    this.post('/admin/products/temporary-links/generate', data);
}

export const TemporaryLinkService = new TemporaryLinkServiceApi(process.env.REACT_APP_API_HOST);
